import { useEffect, useState } from "react";

/**
 * Returns `true` only once `active` has stayed `true` continuously for `delayMs` —
 * the "delayed spinner" pattern. A loading state that resolves inside the window never
 * trips the flag, so a fast async hop shows no intermediate UI (no flash); only a
 * genuinely slow one surfaces a loader. Resets the instant `active` goes false.
 */
export function useDelayedFlag(active: boolean, delayMs: number): boolean {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    if (!active) {
      setElapsed(false);
      return;
    }
    const timer = setTimeout(() => setElapsed(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs]);

  return active && elapsed;
}
